import Swiper from 'swiper';

let viewportWidth = document.documentElement.clientWidth;
let slidersArray = [];

function initGallerySwipe() {
  $('.js-slider-mobile-gallery').each(function (index) {
    if (viewportWidth < 768 && slidersArray[index] == undefined) {
      const $this = $(this);
      const slideView = $this.data('slide');

      $this.addClass(`s-${index}`);

      slidersArray.push(new Swiper(`.s-${index}.swiper-container`, {
        slidesPerView: slideView,
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      }));
    } else if (viewportWidth >= 768 && slidersArray[index] != undefined) {
      slidersArray[index].destroy();
      slidersArray.splice(index, 1);
    }
  });
}

if ($('.js-slider-mobile-gallery').length) {
  initGallerySwipe();
}

$(window).resize(function () {
  viewportWidth = document.documentElement.clientWidth;
  setTimeout(() => {
    initGallerySwipe();
  }, 100);
});